import client from "../client";
import { apiList } from "../apiList";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // returns list of all the people
  getTransactionsForUser: (payload) => client.put(apiList.getTransactionsForCashBook, { json: payload }),
};

// {userId: userId, startDate: startDate, endDate: endDate}